var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-page"},[_c('error-layout',[_c('h1',[_vm._v("Uh oh, something went wrong")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }